module.exports = __webpack_public_path__ + "img/4a2327ec08584348b46659855b6d8c52.cbfd257e.png";